import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '../../../../../frontend/assets/reeach-Logo.svg';
import { BodyText } from '../../../../components/ui/Typography';
import { SIDEBAR_OPTIONS } from './sidebarOptions';

const COLOR_BORDER = 'rgba(0, 0, 0, 0.15)';

interface MobileTopNavProps {
  selectedKey: string | null;
  onSelect: (key: string) => void;
}

const MobileTopNav: React.FC<MobileTopNavProps> = ({ selectedKey, onSelect }) => {
  const { t } = useTranslation();

  return (
    <nav
      className="md:hidden fixed left-0 right-0 z-[110] flex items-stretch bg-white"
      style={{ top: 0 }}
      aria-label="Preview editor navigation">
      <div
        className="flex shrink-0 items-center justify-center w-[67px] min-h-[67px] border border-solid bg-white"
        style={{ borderColor: COLOR_BORDER }}>
        <img src={Logo} alt="Logo" className="max-h-8 w-auto" />
      </div>
      <div className="flex flex-1 min-w-0 -ml-px">
        {SIDEBAR_OPTIONS.map((opt) => {
          const IconComponent = opt.icon;
          const isSelected = selectedKey === opt.key;
          const color = isSelected ? '#3498DB' : 'rgba(0, 0, 0, 0.88)';

          return (
            <button
              key={opt.key}
              type="button"
              className="flex flex-1 min-w-0 flex-col items-center justify-center gap-1 border border-solid bg-white cursor-pointer py-3 px-1 min-h-[67px] transition-colors -ml-px"
              style={{
                borderColor: COLOR_BORDER,
                borderTopColor: isSelected ? '#3498DB' : COLOR_BORDER,
                borderTopWidth: isSelected ? 2 : 1
              }}
              onClick={() => onSelect(opt.key)}>
              <IconComponent style={{ fontSize: "0.875rem", color }} />
              <BodyText
                className="text-center truncate w-full"
                style={{
                  color,
                  fontWeight: isSelected ? 'bold' : 'normal',
                  marginBottom: 0,
                  fontSize: "14px",
                  lineHeight: "23px"
                }}>
                {t(opt.label)}
              </BodyText>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileTopNav;
